import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import {
  SlokaTypeModel,
  BookGetModel,
  SlokaBackendModel,
  PopupAction,
  EventGetModel,
  BlogPostGetModel,
} from '../interfaces/interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PassDataService {
  allSlokaTypes = new BehaviorSubject<SlokaTypeModel[]>([]);
  allBooks = new BehaviorSubject<BookGetModel[]>([]);
  allEvents = new BehaviorSubject<EventGetModel[]>([]);
  allBlogPosts = new BehaviorSubject<BlogPostGetModel[]>([]);
  allUsers = new BehaviorSubject<any[]>([]);
  allSlokas = new BehaviorSubject<SlokaBackendModel[]>([]);
  popup = new BehaviorSubject<{}>([]);
  popupAction = new BehaviorSubject<string>("");
  activatedTitle$ = new Subject<string>();

  popupObject = {
    isPopup: false,
    message: '',
    isOk: false,
    isDelete: false,
    isLoader: false,
    loaderMessage: '',
  };

  constructor() {
    this.popup.next({ ...this.popupObject });
  }

  setAllSlokaTypes(v: SlokaTypeModel[]) {
    this.allSlokaTypes.next(v);
  }

  setAllBooks(v: BookGetModel[]) {
    this.allBooks.next(v);
  }

  setAllEvents(v: EventGetModel[]) {
    this.allEvents.next(v);
  }

  setAllBlogPosts(v: BlogPostGetModel[]) {
    this.allBlogPosts.next(v);
  }

  setAllUsers(v: any[]) {
    this.allUsers.next(v);
  }

  setAllSlokas(v: SlokaBackendModel[]) {
    this.allSlokas.next(v);
  }

  setPopup(v: any) {
    this.popup.next(v);
  }

  setActivatedTitle(a: string) {
    this.activatedTitle$.next(a);
  }

  setPopupAction(v: string) {
    if(v == 'ok' || v == 'cancel') {
      this.popup.next({ ...this.popupObject });
      this.popupAction.next("");
    } else {
      this.popupAction.next(v);
    }
    
  }

  getActivatedTitle(): Observable<string> {
    return this.activatedTitle$.asObservable();
  }

  getAllSlokaTypes(): Observable<SlokaTypeModel[]> {
    return this.allSlokaTypes.asObservable();
  }

  getAllBooks(): Observable<BookGetModel[]> {
    return this.allBooks.asObservable();
  }

  getAllEvents(): Observable<EventGetModel[]> {
    return this.allEvents.asObservable();
  }

  getAllBlogPosts(): Observable<BlogPostGetModel[]> {
    return this.allBlogPosts.asObservable();
  }

  getAllUsers(): Observable<any[]> {
    return this.allUsers.asObservable();
  }

  getAllSlokas(): Observable<SlokaBackendModel[]> {
    return this.allSlokas.asObservable();
  }

  getPopup(): Observable<any> {
    return this.popup.asObservable();
  }

  getPopupAction(): Observable<string> {
    return this.popupAction.asObservable();
  }
}
